<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="tile opacity-container" [class.active]="!store.childOnboardingsLoading()">
  @if (!childOnboardings()?.length) {
    <div class="d-flex justify-content-center align-items-center">
      <div class="text-center mt-4 mb-4">
        <h3>{{ 'child-onboarding.onboardings-list.no-onboardings.headline' | transloco }}</h3>
        <div class="mt-2">{{ 'child-onboarding.onboardings-list.no-onboardings.text' | transloco }}</div>
        <div class="mt-4 d-flex justify-content-center">
          <web-design-system-button (click)="addOnboarding.emit()" [disabled]="!underageOnboardingEnabled()" data-zid="btn-create">{{
            'child-onboarding.onboardings-list.btn-create' | transloco
          }}</web-design-system-button>
        </div>
      </div>
    </div>
  } @else {
    <div class="d-sm-flex justify-content-between align-items-center">
      <h5>{{ 'child-onboarding.onboardings-list.headline' | transloco }}</h5>
      <div class="btn-add">
        <web-design-system-icon-button
          icon="add"
          (click)="underageOnboardingEnabled() && addOnboarding.emit()"
          [disabled]="!underageOnboardingEnabled()"
        >
          {{ 'child-onboarding.onboardings-list.btn-add' | transloco }}
        </web-design-system-icon-button>
      </div>
    </div>

    <hr />
    <div class="mr-2 ml-2">
      <table class="table-simple">
        <thead class="hidden-xs hidden-sm visible-md">
          <tr>
            <th>{{ 'child-onboarding.onboardings-list.list.header.name' | transloco }}</th>
            <th>{{ 'child-onboarding.onboardings-list.list.header.status' | transloco }}</th>
            <th>{{ 'child-onboarding.onboardings-list.list.header.creator' | transloco }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (item of childOnboardings(); track item.onboardingId) {
            <tr>
              <td class="d-block d-md-table-cell">
                <div class="d-flex">
                  <div class="hidden-lg hidden-xl hidden-md flex-xs-grow flex-sm-grow flex-md-grow">
                    {{ 'child-onboarding.onboardings-list.list.header.name' | transloco }}
                  </div>
                  <div class="text-md-left text-right zero-text p-base-med text-nowrap">{{ item.vorname }} {{ item.nachname }}</div>
                </div>
              </td>
              <td class="d-block d-md-table-cell">
                <div class="d-flex">
                  <div class="hidden-lg hidden-xl hidden-md flex-xs-grow flex-sm-grow flex-md-grow">
                    {{ 'child-onboarding.onboardings-list.list.header.status' | transloco }}
                  </div>
                  <div
                    class="text-md-left text-right zero-text p-base-med"
                    [innerHTML]="item | status: (customerId$ | async) === item.legalGuardian2Id"
                  ></div>
                </div>
              </td>
              <td class="d-block d-md-table-cell">
                <div class="d-flex">
                  <div class="hidden-lg hidden-xl hidden-md flex-xs-grow flex-sm-grow flex-md-grow">
                    {{ 'child-onboarding.onboardings-list.list.header.creator' | transloco }}
                  </div>
                  <div class="text-md-left text-right zero-text p-base-med text-nowrap">{{ item.legalGuardian1FullName }}</div>
                </div>
              </td>
              <td class="d-block d-md-table-cell text-right">
                <div class="d-flex justify-content-end align-items-center gap-small">
                  @if ((customerId$ | async) === item.legalGuardian2Id) {
                    @if (item.processStatus === 'AWAITING_LG2CONFIRMATION') {
                      <web-design-system-button
                        size="small"
                        (click)="underageOnboardingEnabled() && confirmOnboarding.emit(item.onboardingId)"
                        [disabled]="!underageOnboardingEnabled()"
                        data-zid="btn-confirm"
                      >
                        {{ 'child-onboarding.onboardings-list.btn-confirm' | transloco }}
                      </web-design-system-button>
                    }
                  } @else {
                    @if (item.processStatus === 'REGISTER') {
                      <web-design-system-button
                        size="small"
                        (click)="continue(item.onboardingId)"
                        [disabled]="!underageOnboardingEnabled()"
                        data-zid="btn-continue"
                      >
                        {{ 'child-onboarding.onboardings-list.btn-continue' | transloco }}
                      </web-design-system-button>
                    } @else {
                      @if (!item.cEmailVerified) {
                        <web-design-system-button
                          size="small"
                          (click)="continue(item.onboardingId)"
                          [disabled]="!underageOnboardingEnabled()"
                          data-zid="btn-continue"
                        >
                          {{ 'child-onboarding.onboardings-list.btn-continue' | transloco }}
                        </web-design-system-button>
                      }
                    }

                    @if (item.processStatus !== 'CONFIRMED') {
                      @if (checkDelete() === item.onboardingId) {
                        <web-design-system-icon-button
                          type="red-light"
                          size="small"
                          icon="trash"
                          [disabled]="store.deletingChildOnboarding()"
                          (click)="deleteOnboarding.emit(item.onboardingId)"
                        />
                        <web-design-system-icon-button type="green-light" size="small" icon="cross" (click)="checkDelete.set(null)" />
                      } @else {
                        <web-design-system-icon-button size="small" icon="trash" (click)="checkDelete.set(item.onboardingId)" />
                      }
                    }
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
